import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  template: `
    <app-header></app-header>
    <main>
      <router-outlet></router-outlet>
    </main>
    <app-footer></app-footer>
  `,
  styles: [`
    main {
      min-height: calc(100vh - 140px);
      padding-top: clamp(70px, 10vw, 80px);
      overflow-x: hidden;
    }
    
    @media (max-width: 768px) {
      main {
        padding-top: clamp(60px, 8vw, 70px);
        min-height: calc(100vh - 120px);
      }
    }
    
    @media (max-width: 480px) {
      main {
        padding-top: clamp(56px, 7vw, 60px);
        min-height: calc(100vh - 100px);
      }
    }
    
    /* Landscape orientation optimization */
    @media (orientation: landscape) and (max-width: 992px) {
      main {
        padding-top: clamp(60px, 8vw, 70px);
        min-height: calc(100vh - 120px);
      }
    }
    
    @media (orientation: landscape) and (max-height: 500px) {
      main {
        padding-top: clamp(56px, 7vw, 64px);
        min-height: calc(100vh - 110px);
      }
    }
  `]
})
export class AppComponent {}